module.exports = __webpack_public_path__ + "media/sessile serrated adenoma.fa21b1ff.wav";